import { FC, memo } from 'react'
import { Button } from '@blueprintjs/core'
import { usePdfEditor } from './PdfEditorProvider'
import useCallbackDebounced from '../../../hooks/shared/useCallbackDebounced'

const SaveButton: FC = () => {
  const { store, onSave, saving, validating, updated, validationErrors, setPreparingSave } =
    usePdfEditor()
  const handleSaveClicked = useCallbackDebounced(() => {
    setPreparingSave(true)
    // delays parsing of store json to blob which will lock up main thread so that the setPreparingSave call ahs time to propagate and start spinning on the ui
    setTimeout(async () => {
      const templateJSON = store.toJSON()
      const templateJSONBlob = new Blob([JSON.stringify(templateJSON)], {
        type: 'application/json',
      })
      const base64PdfUrl = (await store.toPDFDataURL({
        includeBleed: true,
        pixelRatio: 4,
      })) as string
      const blob = await fetch(base64PdfUrl).then(response => response.blob())
      onSave(blob, templateJSONBlob)
      setPreparingSave(false)
    })
  }, [onSave, store, setPreparingSave])
  return (
    <Button
      disabled={saving || !updated || !!validationErrors.length || validating}
      intent="none"
      icon="document"
      onClick={handleSaveClicked}
      loading={saving}
    >
      Save
    </Button>
  )
}

export default memo(SaveButton)
